<template>
  <div class="main print-no-padding" @click.capture="clearPrescriptionReminderFlag">
    <h2 class="is-print-hide title-area">
      <span class="main-title">待审处方</span>
    </h2>
    <div v-if="tabConfig.length > 0" class="list-content">
      <el-tabs v-model="activeName">
        <el-tab-pane
          :key="item.name"
          v-for="item in tabConfig"
          :label="`${item.label}(${item.prescriptionRes.totalCount || 0})`"
          :name="item.name"
        >
          <prescription-table
            :ref="`prescriptionTable-${item.name}`"
            :prescriptionList="item.prescriptionRes.data"
            :list-type="item.listType"
            @refresh="initAllPrescription"
            @handle="item.action"
            @search="params => item.search(params)"
          ></prescription-table>
          <div class="footer is-print-hide">
            <el-pagination
              @current-change="item.handleCurrentChange"
              :current-page="item.prescriptionRes.pageNo"
              :page-size="50"
              layout="prev, pager, next, total, jumper"
              :total="item.prescriptionRes.totalCount"
              class="is-print-hide common-el-pagination"
            ></el-pagination>
            <div class="sureJump is-print-hide global_common_button_goast">确定</div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-empty v-else description="暂无权限查看"></el-empty>
    <drawer
      :visible="approveDrawerVisible"
      title="待审核处方"
      :prescription="prescription"
      @close="approveDrawerVisible = false"
    >
      <approve-footer
        :prescription="prescription"
        @refresh="closeDrawerAndRefreshList('approve')"
        @next="nextDispense"
        @nextPrescription="nextPrescription"
      ></approve-footer>
    </drawer>
    <drawer
      :visible="dispenseDrawerVisible"
      title="待调配处方"
      :prescription="prescription"
      @close="dispenseDrawerVisible = false"
    >
      <dispense-footer
        :prescription="prescription"
        @refresh="closeDrawerAndRefreshList('dispense')"
        @close="closeDrawerAndRefreshList('dispense')"
        @next="nextDispatch"
      ></dispense-footer>
    </drawer>
    <drawer
      :visible="dispatchDrawerVisible"
      title="待发药处方"
      :prescription="prescription"
      @close="closeDrawerAndRefreshList('dispatch')"
    >
      <dispatch-footer
        :prescription="prescription"
        @refresh="closeDrawerAndRefreshList('dispatch')"
        @close="dispatchDrawerVisible = false"
      ></dispatch-footer>
    </drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import prescriptionTable from './components/prescriptionTable';
import drawer from './components/drawer';
import approveFooter from './components/approveFooter';
import dispenseFooter from './components/dispenseFooter';
import dispatchFooter from './components/dispatchFooter';
import { MessageBox } from 'element-ui';
import dayjs from 'dayjs';
import { hasPermission } from '@/util';
import Constant from '@/lib/constant';
import { clearPendingPrescriptionReminder } from '@/util/prescriptionReminder';

const baseRole = Constant.RoleList;
export default {
  components: {
    prescriptionTable,
    drawer,
    approveFooter,
    dispenseFooter,
    dispatchFooter
  },
  data() {
    return {
      activeName: 'approve',
      approvePrescriptionRes: {},
      dispensePrescriptionRes: {},
      dispatchPrescriptionRes: {},
      approveDrawerVisible: false,
      dispenseDrawerVisible: false,
      dispatchDrawerVisible: false,
      prescription: {},
      searchParamsMap: {
        approve: {},
        dispense: {},
        dispatch: {}
      }
    };
  },
  computed: {
    ...mapState('global', ['userInfo']),
    tabConfig() {
      const { approvePrescriptionRes, dispensePrescriptionRes, dispatchPrescriptionRes } = this;
      const { displayConfig } = this.userInfo;
      return [
        {
          label: '待审核',
          name: 'approve',
          prescriptionRes: approvePrescriptionRes,
          listType: 1,
          initPrescription: () => this.initPrescription('approve'),
          search: params => this.search(params, 'approve'),
          handleCurrentChange: val => this.handleCurrentChange(val, 'approve'),
          action: id => this.openDrawer(id, 'approve'),
          hasRight: hasPermission([baseRole.b, baseRole.f])
        },
        {
          label: '待调配',
          name: 'dispense',
          prescriptionRes: dispensePrescriptionRes,
          listType: 2,
          initPrescription: () => this.initPrescription('dispense'),
          search: params => this.search(params, 'dispense'),
          handleCurrentChange: val => this.handleCurrentChange(val, 'dispense'),
          action: id => this.openDrawer(id, 'dispense'),
          hasRight: hasPermission([baseRole.d, baseRole.e, baseRole.f]) && displayConfig?.dispense
        },
        {
          label: '待发药',
          name: 'dispatch',
          prescriptionRes: dispatchPrescriptionRes,
          listType: 3,
          initPrescription: () => this.initPrescription('dispatch'),
          search: params => this.search(params, 'dispatch'),
          handleCurrentChange: val => this.handleCurrentChange(val, 'dispatch'),
          action: id => this.openDrawer(id, 'dispatch'),
          hasRight: hasPermission([baseRole.d, baseRole.e, baseRole.f]) && displayConfig?.dispatch
        }
      ].filter(o => o.hasRight);
    },
    hasDispenseRights() {
      const { displayConfig } = this.userInfo;
      return hasPermission([baseRole.d, baseRole.e, baseRole.f]) && displayConfig?.dispense;
    },
    hasDispatchRights() {
      const { displayConfig } = this.userInfo;
      return hasPermission([baseRole.d, baseRole.e, baseRole.f]) && displayConfig?.dispatch;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.clearPrescriptionReminderFlag();
      vm.punchHint();
    });
  },
  mounted() {
    this.clearPrescriptionReminderFlag();
    this.initAllPrescription();
    this.activeName = this.tabConfig?.[0]?.name;
  },
  activated() {
    this.clearPrescriptionReminderFlag();
  },
  methods: {
    clearPrescriptionReminderFlag() {
      clearPendingPrescriptionReminder();
    },
    async nextPrescription() {
      // 直接处理下一个处方
      this[`approveDrawerVisible`] = false;
      const name = 'approve';
      const config = this.tabConfig.find(o => o.name === name);
      const params = {
        pageNo: 1
      };
      try {
        this[`${config.name}PrescriptionRes`] = await Fetch.prescription_list_to_deal({
          ...params,
          pageSize: Constant.pageSize,
          listType: config.listType
        });
        const $ref = this.$refs[`prescriptionTable-approve`][0];
        this.$nextTick(() => {
          $ref.nextPrescription();
        });
      } catch (e) {
        console.log(e);
      }
    },
    initPrescription(name) {
      const params = {
        pageNo: 1
      };
      this.fetchList(params, name);
    },
    initAllPrescription() {
      this.tabConfig.map(tab => this.initPrescription(tab.name));
    },
    handleCurrentChange(val, name) {
      const params = {
        pageNo: val
      };
      this.fetchList(params, name);
    },
    search(params, name) {
      this.searchParamsMap[name] = params;
      this.fetchList({ pageNo: 1 }, name);
    },
    fetchList(params, name) {
      const config = this.tabConfig.find(o => o.name === name);
      Fetch.prescription_list_to_deal({
        ...this.searchParamsMap[name],
        ...params,
        pageSize: Constant.waitPrescriptionListPageSiz,
        listType: config.listType
      }).then(res => {
        this[`${config.name}PrescriptionRes`] = res;
      });
    },
    async punchHint() {
      const punchOn = this.$store.getters.punchOn;

      if (punchOn) {
        const preKey = `IS_PUNCH${dayjs().subtract(1, 'days').format('YYYYMMDD')}`;

        const key = `IS_PUNCH${dayjs().format('YYYYMMDD')}`;

        if (localStorage.getItem(preKey)) {
          localStorage.removeItem(preKey);
        }

        const isPunch = localStorage.getItem(key) || '';

        const userInfo = this.$store.state.global.userInfo;

        const punchState = await this.$store.dispatch('global/SETpunchState');

        const punchInAndOut = () => this.$store.dispatch('punch/punchInAndOut');

        if (!(isPunch.indexOf(userInfo.userId) > -1) && !punchState) {
          localStorage.setItem(key, isPunch.split(',').concat(userInfo.userId).filter(Boolean).join(','));
          await MessageBox.confirm('您今日尚未通过人脸识别打卡上班，是否先完成打卡？', '没有上班打卡', {
            customClass: 'confirm',
            center: true,
            confirmButtonText: '好，现在就打卡',
            cancelButtonText: '不，先不打卡',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            beforeClose(action, instance, done) {
              switch (action) {
                case 'confirm':
                  done();
                  punchInAndOut();
                  break;
                case 'cancel':
                case 'close':
                  done();
                  break;
              }
            }
          });
        }
      }
    },
    async openDrawer(id, name) {
      const config = this.tabConfig.find(o => o.name === name);
      this.prescription = await Fetch.prescriptionDetail({
        id
      });
      this[`${config.name}DrawerVisible`] = true;
    },
    closeDrawerAndRefreshList(name) {
      this[`${name}DrawerVisible`] = false;
      this.tabConfig.map(tab => this.initPrescription(tab.name));
    },
    nextDispense(id) {
      console.log('### nextDispense', this.hasDispenseRights);
      if (this.hasDispenseRights) {
        this.openDrawer(id, 'dispense');
      }
    },
    nextDispatch(id) {
      console.log('### nextDispatch', this.hasDispatchRights);
      if (this.hasDispatchRights) {
        this.openDrawer(id, 'dispatch');
      }
    }
  }
};
</script>

<style lang="scss">
.tab-pre,
.el-breadcrumb {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
}

.el-table th {
  background: #f7f7f7;
  color: #666;
}

.el-pagination__total,
.el-pagination__jump {
  color: #999;
}
</style>

<style lang="scss" scoped>
// 解决打印样式问题，譬如阴影残留
@media print {
  .list-content {
    background: #ffffff !important;
    border: none !important;
    box-shadow: 0 0px 0px 0 #ffffff !important;
    border-radius: 0px !important;
    padding: 0px !important;
    max-height: auto !important;
  }
}
.title-area {
  overflow: hidden;
  padding-bottom: 10px;
  .main-title {
    float: left;
    line-height: 46px;
  }
  .btn {
    padding: 10px 18px;
    background: #fff;
    border-radius: 3px;
    color: #707070;
    font-size: 12px;
    cursor: pointer;
  }
  .download_result {
    float: right;
    @extend .btn;
    margin-right: 16px;
  }
  .download_select {
    float: right;
    @extend .btn;
  }
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
  max-height: 100%;
  .listSearchArea {
    padding-bottom: 20px;
    // overflow: hidden;
    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .select_from_store_name {
      float: left;
    }
  }
}
.footer {
  overflow: hidden;
  display: flex;
  justify-content: center;
  .sureJump {
    // float: left;
    width: 80px;
    height: 32px;
    // color: #1E8DFF;
    // background: #ffffff;
    // border: 1px solid #1E8DFF;
    border-radius: 3px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 10px;
  }
}
.header_fix {
  // min-width: 1100px;
  // &:after {
  //   content: '.';
  //   display: block;
  //   height: 0;
  //   clear: both;
  //   visibility: hidden;
  // }
  // position: relative;

  // .b1,
  // .b2 {
  //   position: absolute;
  //   bottom: 15px;
  // }
  // .b1 {
  //   right: 0;
  // }
  // .b2 {
  //   right: 200px;
  // }
}
</style>
